import { EnergyInterfaceDetailsPage } from '../energy-interface-details-page/energy-interface-details-page';
import { Component, computed, inject } from '@angular/core';
import { EnergyInterfacesStore } from '../../stores/energy-interfaces.store';
import { EditFormSkeleton } from '../../../../shared/components/edit-form-skeleton/edit-form-skeleton';
import { Alert } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { EnergyInterfaceDetailsAddressEditForm } from '../../components/energy-interface-details-address-edit-form/energy-interface-details-address-edit-form';

@Component({
  selector: 'app-energy-interface-details-address-page',
  imports: [EditFormSkeleton, Alert, NgIcon, TranslocoPipe, EnergyInterfaceDetailsAddressEditForm],
  templateUrl: './energy-interface-details-address-page.html',
})
export class EnergyInterfaceDetailsAddressPage {
  private energyInterfacesStore = inject(EnergyInterfacesStore);

  private detailsPage = inject(EnergyInterfaceDetailsPage);

  protected energyInterfaceId = this.detailsPage.energyInterfaceId;
  protected organizationId = this.detailsPage.organizationId;

  protected energyInterfaceState = computed(() =>
    this.energyInterfacesStore.energyInterfaces()?.find((ei) => ei.id === this.energyInterfaceId()),
  );
}
